exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-text{background-color:#e9ecef;border:1px solid #e9ecef}button#button-models{color:#6c757d!important;background:#ebeff3!important;font-weight:500;margin-bottom:1rem;padding:1px 10px}", ""]);

// exports
